import * as ReactDOM from 'react-dom';
import App from 'moduleBase/containers/App';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import * as React from 'react';
import * as Sentry from '@sentry/react';
import { configureStore, history } from '@collaborator/npm_modules/dist/components/redux';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from 'moduleBase/components/ErrorFallback';
import 'src/css/style.scss';
import Notifier from 'components/notifier/containers/Notifier';
import { FEATURES } from 'src/constants';
import { sentryInit } from 'modules/sentry/init';
import { NetworkServiceInterface } from '@collaborator/npm_modules/dist/components/NetworkService';
import { FeatureFlagProvider } from '@collaborator/npm_modules/dist/components/featureToggle';
import { SweetAlert } from '@collaborator/npm_modules/dist/components/sweetAlert';
import TYPES from 'di/types';
import container from 'di/inversify.config';
import app from 'srcJs/App';

let sentryEnhancer = null;

if (process.env?.SENTRY_ENABLED === '1') {
  sentryInit(
    process.env.SENTRY_DSN,
    parseFloat(process.env.SENTRY_SAMPLE_RATE),
    parseInt(process.env.SENTRY_NORMALIZE_DEPTH, 10),
  );
  sentryEnhancer = Sentry.createReduxEnhancer();
}

const networkService: NetworkServiceInterface = container.get<NetworkServiceInterface>(TYPES.NetworkService);

const store = configureStore({ networkService, app }, sentryEnhancer);

ReactDOM.render(
  (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <FeatureFlagProvider features={FEATURES}>
          <SweetAlert />
          <Notifier />
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <App />
          </ErrorBoundary>
        </FeatureFlagProvider>
      </ConnectedRouter>
    </Provider>
  ),
  document.getElementById('app'),
);
